import React, { useCallback, useMemo, useState } from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    color: theme.palette.grey[700]
  }
}));

type NoteMoreProps = {
  onClick: () => void;
  className?: string;
};

export const NoteMore: React.FC<NoteMoreProps> = ({
  onClick,
  className
}: NoteMoreProps) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const handleMore = useCallback(() => {
    setExpanded((exp) => !exp);
    onClick();
  }, [onClick]);

  const endIcon = useMemo(
    () => (expanded ? <ArrowDropUp /> : <ArrowDropDown />),
    [expanded]
  );

  return (
    <Button
      data-testid="show-note-more-less"
      endIcon={endIcon}
      className={classnames(classes.root, className)}
      onClick={handleMore}
    >
      <FormattedMessage id={expanded ? 'note.less' : 'note.more'} />
    </Button>
  );
};
